import { userLogin } from '@/widget/index';
export function responseInterceptor(response) {
    // 这里对请求response进行处理
    let res = response?.data;
    if (/(403|401)/g.test(res.code)) {
        userLogin();
    }
    else {
        return res;
    }
}
